import {
  FormLabel as CustomLabel,
  FormControl,
  Form,
  Spinner,
} from "react-bootstrap";
import { components } from "react-select";
import { ChevronDown, Plus, X } from "lucide-react";
import CommonButton from "../commonButton";

const FormFeedback = ({ className = "", message = "" }) => {
  return (
    <FormControl.Feedback
      type="invalid"
      className={className}
    >
      {message}
    </FormControl.Feedback>
  );
};
const FormLabel = ({
  className = "",
  id = "",
  labelName = "",
  required = false,
}) => {
  return (
    <CustomLabel className={className} htmlFor={id}>
      {labelName}
      {required && <span className="text-danger"> *</span>}
    </CustomLabel>
  );
};
const DropIcon = (props) => {
  const { selectProps } = props || {};
  const isOpen = !!selectProps?.menuIsOpen;
  return (
    <ChevronDown
      size={18}
      style={{
        transition: "transform 0.3s ease",
        transform: isOpen ? "rotate(-180deg)" : "none",
      }}
      className={isOpen ? "text-primary" : "text-secondary"}
    />
  );
};
const LoadingMessage = (props) => {
  return (
    <components.LoadingMessage {...props}>
      <div className="flex-center gap-2 py-2">
        <Spinner
          animation="border"
          size="sm"
          role="status"
          className="text-primary"
          style={{ width: "14px", height: "14px", borderWidth: "2px" }}
        />
        <span className="text-secondary fs-xs">Loading...</span>
      </div>
    </components.LoadingMessage>
  );
};

const NoOptionsMessage = (props) => {
  const { selectProps } = props;
  const noOptionsAction = selectProps?.noOptionsAction;

  return (
    <components.NoOptionsMessage {...props}>
      <div className="flex-column gap-2 py-2">
        <span className="text-secondary fs-sm">No Options Found</span>
        {noOptionsAction && (
          <CommonButton
            variant="link"
            size="sm"
            className="text-decoration-none"
            onClick={() => {
              if (noOptionsAction.onClick) {
                noOptionsAction.onClick();
                props.selectProps.onMenuClose();
              }
            }}
            icon={<Plus />}
            title={noOptionsAction.label || " Create New"}
          />
        )}
      </div>
    </components.NoOptionsMessage>
  );
};

const ClearIndicator = (props) => {
  return (
    <components.ClearIndicator {...props}>
      <X
        size={14}
        className="text-danger"
      />
    </components.ClearIndicator>
  );
};

const MenuList = (props) => {
  const { children, selectProps } = props;
  const { newOption } = selectProps || {};

  return (
    <components.MenuList {...props}>
      {children}
      {newOption && (
        <div className="sticky-bottom bg-white border-top pt-3 px-1 mt-1 z-2">
          <CommonButton
            variant="link"
            size="sm"
            className="text-decoration-none w-100 text-start shadow-none p-0"
            onClick={() => {
              newOption.onClick?.();
              props.selectProps.onMenuClose?.();
            }}
            icon={<Plus />}
            title={newOption.label || "Add New"}
          />
        </div>
      )}
    </components.MenuList>
  );
};

const MultiValueRemove = (props) => {
  return (
    <components.MultiValueRemove {...props}>
      <X size={12} />
    </components.MultiValueRemove>
  );
};

const CheckboxOption = (props) => {
  return (
    <components.Option {...props}>
      <div className="d-flex align-items-center gap-2">
        <Form.Check
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null} // handled by react-select
          className="m-0 p-0"
          style={{ pointerEvents: 'none' }} // Prevents double click events
        />
        <label className="m-0 cursor-pointer">{props.label}</label>
      </div>
    </components.Option>
  );
};

const MultiValueMessage = (props) => {
  const { index, getValue,message="Selected" } = props;
  const selected = getValue();
  if (index === 0) {
    return (
      <components.MultiValue {...props} className="text-primary p-0 border-0 bg-transparent">
        {selected.length} {message}
      </components.MultiValue>
    );
  }
};
const multiMessageStyle = {
  multiValueRemove: () => ({
    display: 'none',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "transparent"
      : state.isFocused
        ? "var(--bg-main)"
        : state.isSelected && state.isFocused ? "var(--bg-main)" : "transparent",
    color: 'var(-text-primary)',
    ':active': {
      backgroundColor: "var(--primary-100)"
    },
    ':hover': {
      backgroundColor: "var(--bg-main)"
    }
  })
};
const CustomValueContainer = ({ children, ...props }) => {
  const { getValue, hasValue, isMulti, selectProps } = props;
  const hideSelectedChips = selectProps.hideSelectedChips;
  const selectedCount = getValue().filter(v => v.value !== 'all').length;

  if (isMulti && hasValue && hideSelectedChips && selectedCount > 0) {
    return (
      <components.ValueContainer {...props}>
        <div className="d-flex align-items-center" style={{ padding: '2px 8px' }}>
          <span className="text-muted text-truncate me-2" style={{ fontSize: '0.9rem' }}>
            {selectedCount} {selectProps.label?.includes('Cities') ? 'Cities' : selectProps.label?.includes('States') ? 'States' : 'items'} selected
          </span>
        </div>
        {children}
      </components.ValueContainer>
    );
  }

  return <components.ValueContainer {...props}>{children}</components.ValueContainer>;
};


export {
  FormFeedback,
  FormLabel,
  DropIcon,
  LoadingMessage,
  NoOptionsMessage,
  ClearIndicator,
  MenuList,
  MultiValueRemove,
  CheckboxOption,
  MultiValueMessage,
  multiMessageStyle,
  CustomValueContainer
};
